import api from "@/api";

export default {
    namespaced: true,

    state: {

    },

    mutations: {

    },

    actions: {
        async fetchBusinesses(context, data) {
            const url = '/admin/fetchGoogleBusinesses'
            try {
                const response = await api.request("post", url, data);
                return response.data.uid
            } catch (error) {
                throw error;
            }
        },

        async checkStatus(context, taskId) {
            const url = `/admin/google_task/${taskId}/status`
            try {
                const response = await api.request("get", url);
                return response.data
            } catch (error) {
                throw error;
            }
        }
    }
}